export const colors = [
	'#FF6037',
	'#ED0A3F',
	'#E77200',
	'#33CC99',
	'#E667CE',
	'#00468C',
	'#63B76C',
	'#EE34D2',
	'#CCFF00',
	'#0A7E8C',
	'#FF355E',
	'#50BFE6',
	'#9C2542',
	'#0081AB',
	'#6B3FA0',
	'#E30B5C',
	'#CA3435',
	'#4BC7CF',
	'#391285',
	'#736A62',
	'#FC80A5',
	'#FC80A5',
	'#D05340',
	'#14A989',
	'#00CC99',
	'#FF7A00',
	'#008B8B',
	'#8B0000',
	'#4B0082',
];
